module.exports = __webpack_public_path__ + "media/images/page/page_ttl-cf5f735690438a8a19285b04c6f42121.svg";